export const fullFeatureList = [
    {"id":4,"name":"dashboard","description":null,"active":false,"site":"com","attribute_class":"default","attribute_type":null,"attribute_sub_type":null,"attribute_associations":null,"icon_name":null,"tree_number_of_levels":null,"tree_names_of_levels":null,"label":null,"feature_order":null,"extra_destination_columns":null}, 
    {"id":5,"name":"excel","description":null,"active":false,"site":"com","attribute_class":"default","attribute_type":null,"attribute_sub_type":null,"attribute_associations":null,"icon_name":null,"tree_number_of_levels":null,"tree_names_of_levels":null,"label":null,"feature_order":null,"extra_destination_columns":null}, 
    {"id":7,"name":"runtime_item_groups","description":null,"active":true,"site":"com","attribute_class":"default","attribute_type":null,"attribute_sub_type":null,"attribute_associations":null,"icon_name":null,"tree_number_of_levels":null,"tree_names_of_levels":null,"label":null,"feature_order":null,"extra_destination_columns":null}, 
    {
        id: 10,
        name: "sales_territory",
        description: null,
        active: true,
        site: "com",
        attribute_class: "customer",
        attribute_type: "category",
        attribute_sub_type: "flat",
        attribute_associations: ["chain"],
        icon_name: null,
        tree_number_of_levels: null,
        tree_names_of_levels: null,
        label: null,
        feature_order: 2,
        extra_destination_columns: null,
    },
    {
        id: 11,
        name: "chain_status",
        description: null,
        active: true,
        site: "com",
        attribute_class: "customer",
        attribute_type: "category",
        attribute_sub_type: "flat",
        attribute_associations: ["chain"],
        icon_name: null,
        tree_number_of_levels: null,
        tree_names_of_levels: null,
        label: null,
        feature_order: 3,
        extra_destination_columns: null,
    },

    {
        id: 22,
        name: "business_unit",
        description: null,
        active: true,
        site: "com",
        attribute_class: "item",
        attribute_type: "category",
        attribute_sub_type: "tree",
        attribute_associations: null,
        icon_name: null,
        tree_number_of_levels: null,
        tree_names_of_levels: null,
        label: "Business Unit",
        feature_order: 4,
        extra_destination_columns: null,
    },
    {
        id: 23,
        name: "chain_rep",
        description: null,
        active: true,
        site: "com",
        attribute_class: "customer",
        attribute_type: "category",
        attribute_sub_type: "flat",
        attribute_associations: ["chain"],
        icon_name: null,
        tree_number_of_levels: null,
        tree_names_of_levels: null,
        label: "Chain Representative",
        feature_order: 5,
        extra_destination_columns: null,
    },
];
export const storeAttrOptions = [
      {
        id: 1,
        name: "chain_status_chain",
        featureTag: "chain_status",
        attribute_type: "category",
        active: true,
    },
      {
        id: 1,
        name: "sales_territory_chain",
        featureTag: "sales_territory",
        attribute_type: "category",
        active: true,
    },
    {
      id: 23,
      name: "chain_rep",
      featureTag: "chain_rep",
      attribute_type: "category",
      active: true,
    }
];
export const storeGroupByOptions = [
      {
        id: 10,
        name: "kraftheinz_chain",
    },
    {
        id: 11,
        name: "chain_status_chain",
        association: "chain",
    },
    {
        id: 13,
        name: "sales_territory_chain",
        association: "chain",
    },
    {
        id: 23,
        name: "chain_rep",
        association: "chain",
    }
];
export const itemAttrOptions = [
  {
    id: 3,
    name: "business_unit_level_1",
    featureTag: "business_unit",
    label: "Business Unit",
    attribute_type: "category",
    active: true,
  },
  {
    id: 4,
    name: "business_unit_level_2",
    featureTag: "business_unit",
    label: "Category",
    attribute_type: "category",
    active: true,
  },
  {
    id: 5,
    name: "business_unit_level_3",
    featureTag: "business_unit",
    label: "Segment",
    attribute_type: "category",
    active: true,
  },
];
export const storeFilterOptions = [
  {
    id: 4,
    label: "Chain Status",
    source: "parameters.customer_filtering.chain_status_chain_id",
    reference: "kraftheinz_chain_status",
    display_field: "name",
    id_field: "id",
    name: "chain_status_chain",
    athena_column_name: "chain_status_chain_id",
    is_disabled: true,
    featureTag: "chain_status",
  },
  {
    id: 5,
    label: "Chain Sales Territory",
    source: "parameters.customer_filtering.sales_territory_chain_id",
    reference: "kraftheinz_sales_territory",
    display_field: "name",
    id_field: "id",
    name: "sales_territory_chain",
    athena_column_name: "sales_territory_chain_id",
    is_disabled: true,
    featureTag: "sales_territory",
  },
  {
    id: 6,
    label: "Chain Representative",
    source: "parameters.customer_filtering.chain_rep_id",
    reference: "kraftheinz_chain_rep",
    display_field: "name",
    id_field: "id",
    name: "chain_rep",
    athena_column_name: "chain_rep_id",
    is_disabled: true,
    featureTag: "chain_rep",
  },
];
export const itemGroupColumnOptions = [
      {
        id: 1,
        name: "business_unit_level_1",
        featureTag: "business_unit",
    },
    {
        id: 2,
        name: "business_unit_level_2",
        featureTag: "business_unit",
    },
    {
        id: 3,
        name: "business_unit_level_3",
        featureTag: "business_unit",
    },
];
export const runtimeItemGroupFilterOptions = [
      {
        id: 1,
        label: "Business Unit",
        source: "parameters.item_filtering.business_unit_id",
        reference: "kraftheinz_business_unit",
        display_field: "name_path",
        id_field: "id",
        name: "business_unit",
        athena_column_name: "business_unit_id",
        is_disabled: true,
        featureTag: "business_unit",
    },
];